import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { changeDpiDataUrl } from 'changedpi';
import { canvasJsonToImage, exportIMG } from '~core';
import { getState } from '~src/state';
import { addWatermark, getMultiplier } from '~src/utils';
import { isCurrentPage } from '~src/multipages/currentPageImage';
import { getImageFromPage } from './getImageFromPage';

// Restituisce il data URL dell'immagine della pagina scelta, che non è per
// forza quella aperta nel canvas.
export const getSelectedPageImage = async (page, imageFormat) => {
  const project = getState('selected.tipo');

  if (isCurrentPage(page)) {
    const { base64 } = exportIMG(
      1,
      project.outputDpi,
      'base64',
      imageFormat,
      false,
      getMultiplier()
    );
    return base64;
  }

  // getImageFromPage restituisce un JPEG: convertirlo in PNG terrebbe le
  // perdite di compressione e lo sfondo trasparente diventato nero. La pagina
  // si ridisegna dal suo canvasJson con DPI e multiplier della pagina aperta.
  if (imageFormat === 'png') {
    const { base64 } = await canvasJsonToImage(page.canvasJson, {
      outputDpi: project.outputDpi,
      cleanBase64String: false,
      imageFormat: 'png',
      multiplier: getMultiplier(),
    });
    return base64;
  }

  // L'anteprima salvata non porta i DPI di stampa: si scrivono come nel JPEG
  // della pagina aperta.
  const base64 = await getImageFromPage(page);
  return changeDpiDataUrl(
    `data:image/jpeg;base64,${base64}`,
    parseInt(project.outputDpi)
  );
};

export const saveSelectedPageImage = async ({
  page,
  imageFormat,
  fileName,
  withWatermark,
}) => {
  // La pagina aperta esce subito dal canvas; le altre pagine e la filigrana
  // possono richiedere qualche secondo.
  if (withWatermark || !isCurrentPage(page)) {
    Swal.fire({
      text: "Sto generando l'immagine...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  let image;
  try {
    image = await getSelectedPageImage(page, imageFormat);
    if (withWatermark) {
      image = await addWatermark(image);
    }
  } catch (error) {
    // Il caricamento non si può chiudere a mano: resterebbe sopra l'editor.
    Swal.close();
    throw error;
  }

  saveAs(image, fileName);

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata scaricata.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};
